import React from 'react'
import { Link } from 'react-router-dom'

const AdminUnauthorized = () => {
  const styles = {
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh', // Ensures full viewport height
      backgroundColor: '#ecf0f1', // Light background color
    },
    container: {
      textAlign: 'center',
      padding: '50px',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f4f7fa',
      borderRadius: '10px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      maxWidth: '600px', // Optional: to prevent the content from getting too wide
      width: '100%', // Ensures it can shrink on smaller screens
    },
    errorText: {
      color: '#e74c3c',
    },
    message: {
      fontSize: '18px',
      color: '#555',
      marginBottom: '30px',
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      flexWrap: 'wrap',
    },
    button: {
      padding: '12px 20px',
      backgroundColor: '#3498db',
      color: '#fff',
      fontSize: '16px',
      borderRadius: '8px',
      textDecoration: 'none',
      transition: 'background-color 0.3s',
      cursor: 'pointer',
    },
  };
  return (
<div style={styles.wrapper}>
      <div style={styles.container}>
        <h2 style={styles.errorText}>You are not authorized to access this page</h2>
        <p style={styles.message}>It looks like you don't have the necessary permissions to view this page. Please choose one of the following options:</p>
        
        <div style={styles.buttonContainer}>
          <Link to='/admin/dashboard'>
            <p style={styles.button}>Back to Dashboard</p>
          </Link>
          
          <Link to='/admin/login'>
            <p style={styles.button}>Login with Authorized Credentials</p>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default AdminUnauthorized
